import * as ticket from '../../constants/Tickets'

const initialTicketState = {
  barcode: '',
  validationResult: null,
  useManualInput: false,
  overrideModal: {
    visible: false,
    reference: ''
  }
}

export const ticketReducer = (state = initialTicketState, action) => {

  switch (action.type) {
    case ticket.CLEAR_STATE:
      return initialTicketState;
    case ticket.SET_BARCODE:
      return {
        ...state,
        barcode: action.barcode
      }
    case ticket.USE_MANUAL_INPUT:
      return {
        ...state,
        useManualInput: action.useManualInput
      }
    case ticket.VALIDATED_TICKET:
      return {
        ...state,
        barcode: action.validationResult.Barcode,
        validationResult: {
          isValid: action.validationResult.IsValid,
          message: action.validationResult.Message,
          isOverridePossible: action.validationResult.IsOverridePossible
        }
      }
    case ticket.CLEAR_VALIDATION:
      return {
        ...state,
        validationResult: null
      }
    case ticket.CLEAR_BARCODE:
      return {
        ...state,
        barcode: ''
      }
    case ticket.SET_OVERRIDE_MODAL:
      return {
        ...state,
        overrideModal: action.data
      }
    case ticket.SET_OVERRIDE_MODAL_VIEW:
      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          view: action.view
        }
      }
    case ticket.TICKET_ARTICLES_FETCHED:
      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          articles: action.articles
        }
      }
    case ticket.TICKET_CUSTOMERS_FETCHED:
      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          customers: action.customers
        }
      }
    case ticket.SET_TICKET_REFERENCE:
      const refcustomers = [...state.overrideModal.customers];
      var refselectedCustomer = refcustomers.find(customer => customer.Selected);

      if (refselectedCustomer) {
        refselectedCustomer.Selected = false;
      }

      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          reference: action.reference,
          customers: refcustomers
        }
      }
    case ticket.SET_TICKET_QUANTITY:   
      const articles = [...state.overrideModal.articles];
      const article = articles.find(article => article.ArticleNumber === action.articleNumber);
      article.SelectedQuantity = action.quantity;

      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          articles: articles
        }
      }
    case ticket.TOGGLE_SELECTED_CUSTOMER:    
      const customers = [...state.overrideModal.customers];
      var selectedCustomer = customers.find(customer => customer.Selected);

      if (selectedCustomer) {
        selectedCustomer.Selected = false;
      }
      
      if (!(selectedCustomer && selectedCustomer.CustomerId === action.customerId)) {
        selectedCustomer = customers.find(customer => customer.CustomerId === action.customerId);
        selectedCustomer.Selected = true;
      }

      return {
        ...state,
        overrideModal: {
          ...state.overrideModal,
          reference: '',
          customers: customers
        }
      }

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// src/ticket/reducers/ticketReducer.js